const initializeCountryOptionsWithMarketoOptions = require("./initializeCountryOptionsWithMarketoOptions");
const listenToCountrySelectUpdates = require("./listenToCountrySelectUpdates");
const whenCountrySelectUpdates = require("./whenCountrySelectUpdates");

/**
 * @param countrySelect {HTMLSelectElement}
 * @return {Promise<void>}
 */
module.exports = async function initCountrySelect(countrySelect) {
    await initializeCountryOptionsWithMarketoOptions(countrySelect);

    listenToCountrySelectUpdates(countrySelect => {
        whenCountrySelectUpdates(countrySelect)
    });
}